import {
  mergeAttributes,
  Node,
} from '@tiptap/core'

export interface FileOptions {
  HTMLAttributes: Record<string, any>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    file: {
      setFile: (options: { fileId: string }) => ReturnType
      updateFile: (options: { fileId: string }) => ReturnType
    }
  }
}

export const FileSchema = Node.create<FileOptions>({
  name: 'file',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  inline: false,

  group: 'file',

  atom: true,

  draggable: true,

  addAttributes() {
    return {
      fileId: { },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'file',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'file',
      mergeAttributes(
        this.options.HTMLAttributes,
        HTMLAttributes,
      ),
    ]
  },

  addCommands() {
    return {
      setFile: options => ({ commands }) => {
        return commands.insertContent({ type: this.name, attrs: options })
      },
      updateFile: options => ({ commands }) => {
        return commands.updateAttributes(this.name, options)
      },
    }
  },
})
